<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>缴费记录列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>缴费记录列表</span>
        </div>
        <span class="xcx-add left font14" @click="dialogFormVisible = true">添加缴费信息</span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="search.acIndex" placeholder="全部类型">
              <el-option label="请选择" :value="-1"></el-option>
              <el-option label="支付失败" :value="0"></el-option>
              <el-option label="支付成功" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border size="mini" :data="tableData" style="width: 100%" row-key="id" v-loading="loading"
          default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <!-- <el-table-column prop="id" label="ID" width="100"></el-table-column> -->
          <el-table-column prop="order_id" label="订单编号" width="120"></el-table-column>
          <el-table-column prop="nickname" label="用户" width="160"></el-table-column>
          <el-table-column prop="devid" label="设备ID" width="100"></el-table-column>
          <el-table-column prop="dev_id" label="模组ID" width="120"></el-table-column>
          <el-table-column prop="aside_v" label="设备类型" width="160"></el-table-column>
          <el-table-column prop="created_at" label="续费日期" width="160"></el-table-column>
          <el-table-column prop="etime" label="到期日期" width="160"></el-table-column>
          <el-table-column prop="package_title" label="购买套餐" width="160"></el-table-column>
          <el-table-column prop="money" label="订单金额" width="80"></el-table-column>
          <el-table-column prop="price" label="实付金额" width="80"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag size="small" v-if="scope.row.status == 1" type="success" :underline="false">支付成功</el-tag>
              <el-tag size="small" v-else type="danger" :underline="false">支付失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop label="备注"></el-table-column>
          <el-table-column label="操作" width="90">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      page: 0,
      count: 0,
      limit: 10,
      search: {
        keys: "",
        acIndex: -1,
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/package/cat/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        })
        .catch(() => { });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      formData.acIndex = that.search.acIndex;
      that.axios.post("/orders/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.search-box {
  padding: 0 20px;
}
</style>